/**
 * Get the content of a blob als text
 * @param blob blob/file to read
 * @returns blob content
 */
export function blobToString(blob: Blob): Promise<string> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("loadend", function () {
      // reader.result contains the contents of blob as text
      resolve(reader.result as string);
    });
    reader.readAsText(blob);
  });
}

/**
 * Convert a dataURI to a blob (synchronous)
 * @link https://stackoverflow.com/a/12300351/16396979
 * @param {string} dataURI
 */
export function dataURLToBlob(dataURI: string) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = atob(dataURI.split(",")[1]);

  // separate out the mime component
  const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  const ia = new Uint8Array(ab);

  // set the bytes of the buffer to the correct values
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  return new Blob([ab], { type: mimeString });
}

export function blobToDataURL(blob: Blob | File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.onabort = () => reject(new Error("Read aborted"));
    reader.readAsDataURL(blob);
  });
}

export function extensionFromMime(mimeType: string) {
  switch (mimeType) {
    // image
    case "image/jpeg":
      return ".jpg";
    case "image/gif":
      return ".gif";
    case "image/png":
      return ".png";
    case "image/svg+xml":
      return ".svg";
    case "image/webp":
      return ".webp";
    case "image/bpm":
      return ".bmp";
    case "image/tiff":
      return ".tiff";
    case "video/mp4":
      return ".mp4";
    case "video/webm":
      return ".webm";
    case "video/ogg":
      return ".ogg";
    case "video/quicktime":
      return ".mov";
    case "audio/aac":
      return ".aac";
    case "audio/midi":
      return ".midi";
    case "audio/wav":
      return ".wav";
    case "audio/mpeg":
      return ".mp3";

    default:
      return "";
  }
}
